import { render, staticRenderFns } from "./checklists.vue?vue&type=template&id=37e7c646"
import script from "./checklists.vue?vue&type=script&lang=js"
export * from "./checklists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports